// extracted by mini-css-extract-plugin
export default {"root":"style_root__Lm01F","input":"style_input__GhhYa","label":"style_label__j41EO","button":"style_button__HvImw"};